<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/negocio-orcamentos' }">Orçamentos de Negócios</el-breadcrumb-item>
          <el-breadcrumb-item>Pesquisar no SGE</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Pesquisar Orçamentos do Negócios no SGE</h1>
      </el-col>
    </el-row>

    <el-row type="flex" justify="left" :gutter="10" style="">
      <el-col :span="24" style="text-align: left;">
        <el-button type="primary" icon="el-icon-back" @click="$router.go(-1)">Voltar</el-button>
      </el-col>
    </el-row>

    <br/>

    <el-row v-if="permissao.ler_painel" type="flex" justify="left">
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <el-form :inline="true" :model="formPesquisaNegocio" style="text-align: left;" @submit.native.prevent="buscarNegocio">
           <el-form-item label="">
            <el-input 
              ref="inputNegocio"
              v-model="formPesquisaNegocio.negocio" 
              placeholder="Número do Negócio"
              clearable
              @keyup.enter="buscarNegocio"
            >
                <el-button slot="append" type="primary" style = "color: #ffffff; background-color: #409eff;" @click="buscarNegocio" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item> 
        </el-form>
      </el-col>
      <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
        <el-form :inline="true" :model="formPesquisaPeriodo" style="text-align: left;">
          <!-- Campo: Data Início -->
          <el-form-item label="De">
            <el-date-picker
              v-model="formPesquisaPeriodo.data_inicio"
              type="date"
              placeholder="Data início"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsInicio"
              style="width: 140px;">
            </el-date-picker>
          </el-form-item>
          <!-- Campo: Data Fim -->
          <el-form-item label="Até">
            <el-date-picker
              v-model="formPesquisaPeriodo.data_fim"
              type="date"
              placeholder="Data fim"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsFim"
              style="width: 140px;">
            </el-date-picker>
          </el-form-item>
          <!-- Botão: Pesquisar Período -->
          <el-form-item>
            <el-button type="primary" @click="pesquisaPorPeriodo" icon="el-icon-search">
              Pesquisar por Período
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>    

    <el-row type="flex" justify="center" :gutter="10" v-if="negocios.negocio_numero">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: left">
        <p>
          <span v-if="negocios.negocio_numero">Negócio: <b>{{negocios.negocio_numero}}</b></span> <br/><br/>
          <span v-if="negocios.negocio_cliente">Cliente: <b>{{negocios.negocio_cliente.razao_social}}</b></span> <br/>
          <span v-if="negocios.negocio_cliente">Cidade: <b>{{negocios.negocio_cliente.municipio}} - {{negocios.negocio_cliente.uf}} - {{negocios.negocio_cliente.pais}}</b></span>
        </p>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" :gutter="10" v-if="negocios.negocio_numero">
      <h3>Negócios no SGE</h3>
    </el-row>

    <el-row type="flex" justify="center" :gutter="10" v-if="negocios.negocio_numero">
      <el-table 
        :data="negocios.negocios_sge" 
        class="main-table" 
        style="width: 98%" 
        row-key="negocio_versao"
        :expand-row-keys="expandedRows"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              class="second-table"
              v-if="props.row.versao_divisao && props.row.versao_divisao.length"
              :data="props.row.versao_divisao"
              style="width: 95%; margin-left: 50px"
            >
              <el-table-column prop="negocio_divisao" label="Divisão" width="70">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="getDivisaoSGETooltip(scope.row)"
                    placement="top"
                  >
                    <span>{{ scope.row.negocio_divisao}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="negocio_atividade" label="Atividade" width="85">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="getAtividadeSGETooltip(scope.row)"
                    placement="top"
                  >
                    <span>{{ scope.row.negocio_atividade}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="negocio_sequencia" label="Sequência" width="95"></el-table-column>
              <el-table-column prop="titulo" label="Título" min-width="250"></el-table-column>
              <el-table-column prop="geracao" label="Geração" width="95"></el-table-column>
              <el-table-column prop="valorizacao" label="Valorização" width="190"></el-table-column>
            </el-table>
            <div v-else style="margin-left: 50px">
              Nenhum registro.
            </div>
          </template>
        </el-table-column>
        <el-table-column class="fundo-principal" prop="negocio_versao" label="Versão" width="95"></el-table-column>
        <el-table-column class="fundo-principal" prop="negocio_versao_historico" label="Histórico da Versão" min-width="290"></el-table-column>
        <el-table-column
          class="fundo-principal"
          label="Ações"
          width="180"
          align="right">
          <template slot-scope="scope">
            <el-tooltip v-if="permissao.editar_painel" class="item" effect="light" content="Criar Revisão da Versão do Negócio do SGE" placement="top">
              <el-button
                v-if="scope.row.criar_revisao_negocio"
                class="details-icon-button"
                size="mini"
                type="warning"
                icon="el-icon-circle-plus-outline"
                @click="negocioCriarRevisao(scope.row)"> Criar Revisão da Versão</el-button>
            </el-tooltip> 
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" justify="center" :gutter="10" v-if="negocios.negocio_numero">
      <h3>Negócios na Intranet</h3>
    </el-row>
    <el-row type="flex" justify="center" :gutter="10" v-if="negocios.negocio_numero">
      <el-table 
        :data="negocios.negocios_intranet" 
        class="main-table" 
        style="width: 98%" 
        row-key="chave_unica"
        :expand-row-keys="expandedRows"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              class="second-table"
              v-if="props.row.versao_revisao_divisao && props.row.versao_revisao_divisao.length"
              :data="props.row.versao_revisao_divisao"
              style="width: 95%; margin-left: 50px"
            >
              <el-table-column prop="negocio_divisao" label="Divisão" width="70">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="getDivisaoSGETooltip(scope.row)"
                    placement="top"
                  >
                    <span>{{ scope.row.negocio_divisao}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="negocio_atividade" label="Atividade" width="85">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="getAtividadeSGETooltip(scope.row)"
                    placement="top"
                  >
                    <span>{{ scope.row.negocio_atividade}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="negocio_sequencia" label="Sequência" width="95"></el-table-column>
              <el-table-column prop="titulo" label="Título" min-width="250"></el-table-column>
              <el-table-column class="fundo-principal" prop="valor_total" label="Total Atividade" width="130" align="right" header-align="right"></el-table-column>
              <el-table-column prop="geracao" label="Geração" width="95"></el-table-column>
              <el-table-column prop="valorizacao" label="Valorização" width="190"></el-table-column>
              <el-table-column
                label="Ações"
                min-width="130"
                align="right">
                <template slot-scope="scope">
                    <el-tooltip v-if="permissao.ler_painel" class="item" effect="light" content="Editar a Atividade da Divisão do Orçamento do Negócio" placement="top">
                      <el-button
                        class="details-icon-button"
                        size="mini"
                        type="primary"
                        icon="el-icon-edit"
                        @click="vaiNegocioOrcamentoDivisao(scope.row)">
                      </el-button>
                    </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <div v-else style="margin-left: 50px">
              Nenhum registro.
            </div>
          </template>
        </el-table-column>
        <el-table-column class="fundo-principal" prop="negocio_versao" label="Versão" width="95"></el-table-column>
        <el-table-column class="fundo-principal" prop="negocio_revisao" label="Revisão" width="95"></el-table-column>
        <el-table-column class="fundo-principal" prop="nome" label="Histórico da Revisão" min-width="250"></el-table-column>
        <el-table-column class="fundo-principal" prop="valor_total" label="Total Revisão" width="130" align="right" header-align="right"></el-table-column>
        <el-table-column prop="simulacao" label="Simulação" width="95"></el-table-column>
        <el-table-column prop="consolidado" label="Consolidado" width="105"></el-table-column>
        <el-table-column class="fundo-principal" prop="fechamento" label="Fechamento" width="130" align="right" header-align="right"></el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" justify="center" :gutter="10" v-if="negociosSGE.length>0">
      <el-table 
        :data="negociosSGE" 
        class="main-table" 
        style="width: 98%" 
        row-key="negocio_versao"
        :expand-row-keys="expandedRows"
      >
        <el-table-column prop="NEGOCIO" label="Negógio" width="100" sortable></el-table-column>
        <el-table-column prop="OBRA" label="Obra" width="60"></el-table-column>
        <el-table-column prop="NOME" label="Nome" min-width="300" sortable></el-table-column>
        <el-table-column prop="GERACAO" label="Geração" width="110" sortable></el-table-column>
        <el-table-column prop="VALIDADE" label="Validade" width="80"></el-table-column>
        <el-table-column
          class="fundo-principal"
          label="Ações"
          width="65"
          align="right">
          <template slot-scope="scope">
            <el-tooltip 
               v-if="permissao.ler_painel" 
               class="item" 
               effect="light" 
               :content="mensagemNegocio(scope.row)"
               placement="top"
            >
              <el-button
                class="details-icon-button"
                size="mini"
                type="primary"
                icon="el-icon-document"
                @click="pesquisaNegocio2(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
    </el-row>

</div>
</template>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      loading: false,
      negocios: [],
      negociosSGE: [],
      expandedRows: [],
      total: 0,
      pageSize: 12,
      listLoading: false,
      currentPage: 1,
      negocioNumero: null,
      negocioCliente: null,
      negocioClienteCidade: null,
      listaNegociosSGE: [],
      listaNegociosIntranet: [],
      itens: [],
      permissao: {},
      formPesquisaNegocio: {
        negocio: null,
      },
      formPesquisaPeriodo: {
        data_inicio: '',
        data_fim: ''
      },
      pickerOptionsInicio: {
        disabledDate(time) {
          // Não permite data futura além de hoje
          return time.getTime() > Date.now();
        }
      },
      pickerOptionsFim: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      ruleFormEdit: {
        nome: "",
        email: "",
        id: "",
      },
      rules: {
        nome: [
          {
            required: true,
            message: "Por Favor, informe o Nome",
            trigger: "blur",
          },
          {
            min: 3,
            message: "Deve ter pelo menos 3 caracteres",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "Informe o e-mail.", trigger: "blur" },
          {
            type: "email",
            message: "Informe um e-mail válido.",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    this.inicializarDatas();
    if (!this.permissao.ler_painel) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.$nextTick(() => {
      // Enviar foco da janela para o input padrão ao entrar
      this.$refs.inputNegocio.focus()
    })    
  },
  methods: {
    inicializarDatas() {
      const hoje = new Date();
      const cincoDiasAtras = new Date();
      cincoDiasAtras.setDate(hoje.getDate() - 5);

      this.formPesquisaPeriodo.data_inicio = this.formatarData(cincoDiasAtras);
      this.formPesquisaPeriodo.data_fim = this.formatarData(hoje);
    },
    formatarData(date) {
      return date.toISOString().split('T')[0]; // '2025-11-07' 'YYYY-MM-DD'
    },
    //PESQUISA
    async buscarNegocio() {
      try {

        this.loading = true;
        this.negocios = [];
        this.negociosSGE = [];

        const negocioId = this.formPesquisaNegocio.negocio;
        if (!negocioId || isNaN(negocioId)) {
          this.$notify.warning({ title: 'Atenção', message: 'Digite um número de negócio válido.' });
          return;
        }

        this.formPesquisaNegocio.negocio = null;

        const response = await axios.get(url + "/negocio-orcamento/"+negocioId, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          }
        });
        if (response.status === 401) {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
          return;
        }
        if (!Array.isArray(response.data) && typeof response.data !== "object") {
          throw new Error("Dados recebidos não estão no formato esperado");
        }
        // console.log("API X124:", response.data);
        this.negocios = response.data;
        this.$notify({
          title: "Sucesso",
          message: "Pesquisa realizada com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$notify({
          title: "Erro",
          message: `Falha ao realizar a pesquisa: ${error.message}`,
          type: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    async pesquisaPorPeriodo() {
      try {

        this.loading = true;
        this.negociosSGE = [];
        this.negocios.negocio_numero = null;

        const { data_inicio, data_fim } = this.formPesquisaPeriodo;

        if (!data_inicio || !data_fim) {
          this.$notify.warning({ title: 'Atenção', message: 'Selecione o período.' });
          return;
        }

        const params = new URLSearchParams({
          data_inicio,
          data_fim
        }).toString();

        const response = await axios.get(`${url}/negocio-orcamento-periodo?${params}`, {
          headers: { Authorization: `Bearer ${this.$store.state.token}` }
        });

        if (response.status === 401) {
          await this.$store.dispatch('logout');
          this.$router.push('/login');
          return;
        }

        this.negociosSGE = Array.isArray(response.data) ? response.data : [];
        // console.log(this.negociosSGE);

        this.$notify.success({
          title: 'Sucesso',
          message: `Encontrados ${this.negociosSGE.length} negócio(s) no período.`
        });

      } catch (error) {
        this.$notify.error({
          title: 'Erro',
          message: `Falha na pesquisa por período: ${error.response?.data?.message || error.message}`
        });
      } finally {
        this.loading = false;
      }
    },
    //FIM PESQUISA
    //EDITAR
    handleEdit(index, row) {
      //this.$router.push({ name: "editOrcamento", params: { id: row.id } });
      this.$router.push({ name: "cadNovaVersao", params: { id: row.id } });
    },
    //FIM EDITAR
    //VISUALIZAR
    handleVisualizar(index, row) {
      this.$router.push({ name: "visOrcamento", params: { id: row.id } });
    },
    //FIM VISUALIZAR


    //EXCLUIR
    handleDelete(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/orcamentos/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDados();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    getAtividadeTooltip(row) {
      return 'Atividade: ' + row.atividade || '—';
    },
    getDivisaoTooltip(row) {
      return 'Divisão: ' + row.divisao || '—';
    },

    //FIM EXCLUIR






    redirecionarPara(url) {
      window.location.href = url;
    },

    getDivisaoSGETooltip(row) {
      return (row.negocio_divisao_descricao || '—');
    },
    getAtividadeSGETooltip(row) {
      return (row.negocio_atividade_descricao || '—');
    },
    getAtividadeSGETooltip2(row) {
      return 'Atividade: ' + row.ATIVIDADE || '—';
    },

    async negocioCriarRevisao(row) {

      // console.log("Iniciar Criação de Revisão");

      try {

        this.loading = true

        // console.log("Criar Revisão:", this.negocios);
        // console.log("Criar Revisão - Row:", row);
        // console.log("Negócio Numero: ",this.negocios.negocio_numero);
        // console.log("Cliente Codigo: ",this.negocios.negocio_cliente.cliente_cod);

        const dados = {
          negocio_numero: this.negocios.negocio_numero,
          negocio_versao: row.negocio_versao,
          negocio_cliente_cod: this.negocios.negocio_cliente.cliente_cod,
          negocio_historico_versao: row.negocio_versao_historico
        };

        // console.log("Dados enviados:", dados);      

        const response = await axios.post(url+"/negocio-criar-revisao/", dados, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        // console.log("Resposta da API: #103", response.data);
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          // console.log("Resposta da API:", response.data);
          this.tabelaEditaveis = [];
        }
        //this.$notify({ title: "Sucesso", message: "Produtos atualizados com sucesso!", type: "success" });

      } catch (error) {

        if (error.response && error.response.data.message) {
          const mensagem = error.response.data.message;
          // console.log('Mensagem de erro:', mensagem);
          this.$notify.error(mensagem);
        }
                
        // this.$notify({
        //   title: "Erro",
        //   message: "Não foi possível atualizar o produto." + error.message,
        //   type: "error"
        // });
        
      } finally {
        this.loading = false;
      }

      this.formPesquisaNegocio.negocio = this.negocios.negocio_numero;
      this.buscarNegocio();

      // // Monta os parâmetros
      // const dados = {
      //   negocio_numero: this.negocios.negocio_numero,
      //   negocio_versao: row.negocio_versao
      // };

      // // Navega para a rota com parâmetros
      // this.$router.push({
      //   path: '/detalhes-negocio',
      //   dados: dados
      // });


    },
    pesquisaNegocio2(row) {
      this.formPesquisaNegocio.negocio = row.NEGOCIO;
      this.buscarNegocio();

    },
    showDetails2(row) {
      this.$alert(`Detalhes da Divisão: ${row.negocio_divisao_descricao} - Atividade: ${row.negocio_atividade_descricao} - Sequência: ${row.negocio_sequencia}`, 'Detalhes', {
        confirmButtonText: 'OK',
        callback: action => {
          console.log('action:', action);
          // console.log('Detalhes exibidos para:', row);
        }
      });
    },
    mensagemNegocio(row) {
      const negocio = row.NEGOCIO || '—';
      return `Apresentar Negócio do SGE número ${negocio}`;
    },
    vaiNegocioOrcamentoDivisao(row) {
      this.$router.push({ name: "NegocioOrcamentosDivisao", params: { id: row.id } });
    },





  },
};
</script>

<style scoped>

  .el-table {
    box-sizing: border-box;
  }
  .el-table th,
  .el-table td {
    display: table-cell !important;
    text-align: left;
    padding: 10px;
  }
  .el-table__header,
  .el-table__body {
    width: 100%;
    table-layout: fixed;
  }
  .el-table .el-table__cell {
    padding: 0;
  }
  .details-icon-button.el-button--mini {
    padding: 5px;
  }
  .item {
    margin:0;
  }
  .main-table .el-table__body-wrapper /deep/.el-table__row /deep/.el-table__cell {
    background-color: #f0f9eb !important;
  }
  .second-table .el-table__body-wrapper /deep/.el-table__row /deep/.el-table__cell {
    background-color: white !important;
  }
    
  .el-row-topo {
    margin-top: 10px;
  }
</style>

